import { queryOptions } from '@tanstack/react-query'
import { apiExchange, apiGet, ApiError } from './client'
import { saveBytes } from './inventoree'
import type { AdmFilterValues } from './admErrors'
import type { AdmView } from './admDashboard'

/**
 * ADM -> Coverage, calea noua. Perechile vechi, din
 * `application/controllers/Adm.php`:
 *
 *   coverage()          -> GET /adm/coverage
 *   exportCoverage()    -> GET /adm/coverage/export.xlsx
 *   exportCoveragePdf() -> GET /adm/coverage/export.pdf
 *
 * TREI NUMERE, ANUME NEADUNATE INTR-UNUL: configurat, gasit, corelat. Un singur
 * procent ascunde care din trei e cel scurt, si au trei leacuri diferite.
 *
 * TINTELE SE SCRIU LANGA PROCENTE (28 octombrie 2026). Pana atunci veneau in
 * raspuns si nu se desenau, iar ecranul n-avea nici intrare de meniu: nimeni
 * nu vedea cat de departe e descoperirea de 80% si corelarea de 70%.
 */

export interface CoverageRow {
  company_id: number
  company_name: string
  day: string
  ci_total: number
  ci_with_agent: number
  ci_with_telemetry: number
  flows_correlated: number
  relations_total: number
  coverage_pct: number
  correlation_pct: number
  coverage_met: boolean
  correlation_met: boolean
}

/** Un client pentru care nu s-a scris niciodata un rand de rezumat. */
export interface CoverageMissing {
  ID: number
  company_name: string
  devices: number
}

export interface CoverageScreen {
  pageTitle: string
  pageHeader: string
  breadcrumbs: string[]
  windows: number[]
  filters: AdmFilterValues
  rows: CoverageRow[]
  missing: CoverageMissing[]
  targets: { coverage: number; correlation: number }
  /** Banda de vederi a descoperirii, filtrata pe server - acoperirea e o fila a ei. */
  views: AdmView[]
  /** Ziua din care vorbeste tabelul - „as of ...". */
  day: string
  itemsOnRecord: number
  /**
   * Serverul asta chiar poate scoate un PDF?
   *
   * v4/api nu poarta nicio biblioteca de PDF, iar rezerva scrie un fisier care
   * poarta cuvintele dar pe care un cititor nu-l aseaza in pagina. Butonul se
   * deseneaza numai cand raspunsul e „da": unul care da inapoi un fisier
   * stricat e mai rau decat unul care lipseste, fiindca omul crede ca are
   * dovada in dosar.
   */
  pdfAvailable: boolean
}

export function coverageScreenQuery(days: number) {
  return queryOptions({
    queryKey: ['adm', 'coverage', days],
    queryFn: () => apiGet<CoverageScreen>(`/adm/coverage?days=${days}`),
  })
}

/** Foaia de calcul - aceleasi filtre ca ecranul, deci ce se descarca e ce se vede. */
export async function downloadCoverageXlsx(days: number): Promise<void> {
  const out = await apiExchange(`/adm/coverage/export.xlsx?days=${days}`, { method: 'GET' })
  saveBytes(out.bytes, out.type, out.filename, 'coverage.xlsx')
}

/**
 * Pagina de tiparit.
 *
 * Cand serverul n-are cu ce s-o scoata raspunde 501 cu o propozitie, si aia se
 * arata - nu se salveaza un fisier care nu e un PDF.
 */
export async function downloadCoveragePdf(days: number): Promise<void> {
  const out = await apiExchange(`/adm/coverage/export.pdf?days=${days}`, { method: 'GET' })

  if (!out.type.includes('pdf')) {
    let message = 'The coverage PDF could not be produced.'
    try {
      message = (JSON.parse(out.text) as { message?: string }).message ?? message
    } catch {
      /* Raspunsul nu era JSON; ramane propozitia de mai sus. */
    }
    throw new ApiError(out.status || 501, message)
  }

  saveBytes(out.bytes, out.type, out.filename, 'coverage.pdf')
}
